import { patientApi } from '@/api/PatientApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useUpdatePatientProfile = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			firstName,
			lastName,
			phone,
		}: { firstName?: string; lastName?: string; phone?: string }) =>
			patientApi.updatePatientProfile({ firstName, lastName, phone }),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['patient-info'],
			})
		},
	})
}

export { useUpdatePatientProfile }
